import { API_CONTACTS } from 'config'
import Api from 'services/api'

export const getContacts = () => {
  return Api.get(API_CONTACTS)
}
